<div class="ui-modal">
    <div class="header flex-row space-between-center">
        {{ 'MONITORING_PAGE.CREATE_CONTACT_MODAL.TITLE' | translate }}
        <span class="ui-icon-close c-p"
              mat-dialog-close></span>
    </div>

    <div class="body flex-col gap-16"
         [formGroup]="contactForm">
        <div class="flex-col gap-8">
            <label>{{ 'MONITORING_PAGE.CREATE_CONTACT_MODAL.LABELS.NAME' | translate }}
                <span class="required">*</span>
            </label>
            <input class="ui-input ui-input-40"
                   formControlName="name" />
        </div>

        <div class="separator"></div>

        <div class="flex-col gap-8">
            <label>
                {{ 'MONITORING_PAGE.CREATE_CONTACT_MODAL.LABELS.EMAIL' | translate }}
                <span class="required">*</span>
            </label>
            <div class="emails-container flex-col gap-8">
                <input class="ui-input ui-input-40 w-100"
                       formControlName="email" />
            </div>
        </div>

        <div class="flex-col gap-8">
            <label>
                {{ 'MONITORING_PAGE.CREATE_CONTACT_MODAL.LABELS.PHONE' | translate }}
            </label>
            <div class="phones-container flex-col gap-8">
                <ui-phone-input-v2 formControlName="phone"></ui-phone-input-v2>
            </div>
        </div>

        <div class="separator"></div>

        <div class="flex-col gap-8">
            <label>{{
                'MONITORING_PAGE.CREATE_CONTACT_MODAL.LABELS.ROLES' | translate
                }}</label>
            <input class="ui-input ui-input-40"
                   formControlName="position" />
        </div>

        <mat-checkbox formControlName="contactOnWeekend">
            {{ 'MONITORING_PAGE.CREATE_CONTACT_MODAL.LABELS.WEEKEND' | translate }}
        </mat-checkbox>

        <mat-checkbox formControlName="contactOnShabbat">
            {{ 'MONITORING_PAGE.CREATE_CONTACT_MODAL.LABELS.SHABBAT' | translate }}
        </mat-checkbox>
    </div>
    <div class="footer flex-row end-center">
        <ui-button [disabled]="contactForm.invalid"
                   type="primary"
                   [loading]="selectIsCreatingLoader() || selectIsLoadingLoader()"
                   [text]="'COMMON.ADD' | translate"
                   (click)="createContact()">
        </ui-button>
    </div>
</div>